import React from 'react';
import { FmRankedList } from '../FmRankedList';
import { FmTimeline } from '../FmTimeline';
import { toRankedListItems, toTimelineItem } from './elementAdapters';
import { derivedTestId, useElementContext } from './elementContext';
import type { FmRankedListElement, FmTimelineElement } from './elements.types';
import './FmElements.css';

/**
 * A ranked list of served rows. An empty list renders its own empty label so a
 * section with nothing ranked still says so where the list would be.
 */
export const FmRankedListElementView: React.FC<{ element: FmRankedListElement }> = ({
  element,
}) => {
  const context = useElementContext();
  const items = toRankedListItems(element.rows);
  if (!items.length) {
    return (
      <div className="fm-element-unavailable" data-state="empty" data-testid={element.testId}>
        {element.emptyLabel}
      </div>
    );
  }
  return (
    <FmRankedList
      items={items}
      title={element.title}
      valueHeader={element.valueHeader}
      limit={element.limit}
      highlightTop={element.highlightTop ?? 0}
      tone={context.contrast}
      data-testid={derivedTestId(context, element.testId, 'ranked-list')}
    />
  );
};

/** Dated events on the shared timeline; ids stay `<base>-timeline` and `<base>-timeline-item`. */
export const FmTimelineElementView: React.FC<{ element: FmTimelineElement }> = ({ element }) => {
  const context = useElementContext();
  const testId = derivedTestId(context, element.testId, 'timeline');
  return (
    <figure className="fm-element-timeline">
      <FmTimeline
        items={element.events.map(toTimelineItem)}
        testId={testId}
        itemTestId={`${testId}-item`}
      />
    </figure>
  );
};
